import { INVOICE_CURRENCY } from "../constants";

// Builders puros del multipart de factura: arman y devuelven un FormData a partir
// de los valores del formulario y el archivo. No mutan nada. Estaban inline y
// repetidos en cada diálogo de carga.

/**
 * itbmsTax, subtotal, total e invoiceNumber llegan como number o string según el
 * diálogo: unos usan defaultValues numéricos, otro valida con yup.string(). Se
 * tipan `number | string` tal cual llegan hoy (comportamiento preexistente, no se
 * corrige en esta migración tipo-only) y se envuelven con `String()` al hacer
 * `.append()` porque `FormData.append()` solo admite `string | Blob`; el DOM ya
 * convertía estos valores a string implícitamente, así que el resultado es idéntico.
 */
export interface InvoiceFormValues {
  ccEmail: string;
  comments: string;
  itbmsTax: number | string;
  subtotal: number | string;
  total: number | string;
}

export interface ManualInvoiceFormValues extends InvoiceFormValues {
  invoiceNumber: number | string;
  invoiceDate: Date;
}

const toIsoDate = (date: Date): string => date.toISOString().substring(0, 10);

/** Carga manual de factura desde el panel interno (incluye subTypes). */
export const buildManualInvoiceFormData = (
  value: ManualInvoiceFormValues,
  file: File,
  subTypes: string
): FormData => {
  const formData = new FormData();
  formData.append("file", file);
  formData.append("currency", INVOICE_CURRENCY);
  formData.append("ccEmail", value.ccEmail);
  formData.append("comments", value.comments);
  formData.append("itbmsTax", String(value.itbmsTax));
  formData.append("subtotal", String(value.subtotal));
  formData.append("total", String(value.total));
  formData.append("subTypes", subTypes);
  formData.append("invoiceNumber", String(value.invoiceNumber));
  formData.append("invoiceDate", toIsoDate(value.invoiceDate));
  return formData;
};

/** Carga manual pública (link con token): igual que la interna pero sin subTypes. */
export const buildPublicManualInvoiceFormData = (value: ManualInvoiceFormValues, file: File): FormData => {
  const formData = new FormData();
  formData.append("file", file);
  formData.append("currency", INVOICE_CURRENCY);
  formData.append("ccEmail", value.ccEmail);
  formData.append("comments", value.comments);
  formData.append("itbmsTax", String(value.itbmsTax));
  formData.append("subtotal", String(value.subtotal));
  formData.append("total", String(value.total));
  formData.append("invoiceNumber", String(value.invoiceNumber));
  formData.append("invoiceDate", toIsoDate(value.invoiceDate));
  return formData;
};

/** Reenvío de una factura existente: lleva invoiceId, sin currency ni número/fecha. */
export const buildResendInvoiceFormData = (
  value: InvoiceFormValues,
  file: File,
  invoiceId: number
): FormData => {
  const formData = new FormData();
  formData.append("file", file);
  formData.append("invoiceId", String(invoiceId));
  formData.append("ccEmail", value.ccEmail);
  formData.append("comments", value.comments);
  formData.append("itbmsTax", String(value.itbmsTax));
  formData.append("subtotal", String(value.subtotal));
  formData.append("total", String(value.total));
  return formData;
};
